<template>
  <div class="row">
    <div class="col-12">
      <b-button
        variant="warning"
        @click="toBack"
      >
        {{$t('modal.button.back')}}
      </b-button>
    </div>

    <div class="col-12 mb-3">
      <div class="_table">
        <b-table
          :fields="fields"
          :items="products"
        >
          <template #cell(should_return)="{item}">
            <span v-if="item.should_return">
              {{$t('general.should_returnTrue')}}
            </span>
            <span v-else>
              {{$t('general.should_returnFalse')}}
            </span>
          </template>

          <template #cell(pivot)="{item}">
            <b-button
              v-if="item.pivot.direction === 0"
              variant="primary"
              size="sm"
            >
              <i class='bx bxs-truck fs-4'></i>
              <i class="bx bx-right-arrow-alt fs-4"></i>
            </b-button>

            <b-button
              v-if="item.pivot.direction === 1"
              variant="success"
              size="sm"
            >
              <i class="bx bx-left-arrow-alt fs-4"></i>
              <i class='bx bxs-truck bx-flip-horizontal fs-4' ></i>
            </b-button>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
  import {showManagerWaterRound} from '../../../../api/endpoints/managerWaterRound'

  export default {
    name: "ManagerWaterRound-Products",
    data() {
      return {
        items: [],
        products: [],
        fields: [
          // {key: "id", label: "№"},
          {key: "name", label: this.$t('table.name.label')},
          {key: "should_return", label: this.$t('general.should_return')},
          // {key: "pivot.water_round_id", label: this.$t('general.water_round_id')},
          {key: "pivot.quantity", label: this.$t('table.quantityNotSold.label')},
          {key: "pivot", label: this.$t('table.direction')},
        ],
      }
    },
    mounted() {
      this.getProductsByUser();
    },
    methods: {
      getProductsByUser() {
        showManagerWaterRound(this.$route.params.id)
          .then( res => {
            this.products = res.data.data.products;
          })
          .catch( () => {
          this.$router.push("/manager/water-round")
          })
      },
      toBack() {
        this.$router.push("/manager/water-round")
      }
    }
  }
</script>